import React, { useEffect, useState } from "react";

export default function ScrollIndicator({ locoScroll, targetRef }) {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const fadeStart = 0;
    const fadeEnd = 200;
    const calcOpacity = (y) => {
      if (y <= fadeStart) return 1;
      if (y >= fadeEnd) return 0;
      const t = (y - fadeStart) / (fadeEnd - fadeStart);
      return 1 - t;
    };

    let rafId = 0;
    const tick = () => {
      const target = targetRef?.current;
      let y = 0;
      if (target) {
        const rect = target.getBoundingClientRect();
        y = Math.max(0, -rect.top);
      } else if (locoScroll) {
        y =
          locoScroll?.scroll?.instance?.scroll?.y ??
          locoScroll?.scroll?.instance?.delta?.y ??
          0;
      } else {
        y = window.scrollY;
      }
      setOpacity(calcOpacity(y));
      rafId = window.requestAnimationFrame(tick);
    };
    tick();
    return () => window.cancelAnimationFrame(rafId);
  }, [locoScroll, targetRef]);

  return (
    <div
      id="scroll-indicator"
      className="scroll-container d-none d-sm-block"
      style={{
        opacity,
        visibility: opacity === 0 ? "hidden" : "visible",
        pointerEvents: opacity === 0 ? "none" : "auto",
      }}
      aria-hidden={opacity === 0}
    >
      <span className="scroll-text">SCROLL DOWN</span>
      <div className="scroll-mouse">
        <div className="scroll-wheel" />
      </div>
      <span className="scroll-text-bottom">
        VFX • Animation • Creative Direction
      </span>
    </div>
  );
}
